import { render, staticRenderFns } from "./ModulesOverview.vue?vue&type=template&id=68790c8f"
import script from "./ModulesOverview.vue?vue&type=script&lang=js"
export * from "./ModulesOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports